import DatePicker_ from 'components/global/Datepicker'
import SelectBox from 'components/global/SelectBox';
import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setNextCompaignTab } from 'redux/actions/newCompaignActions';
import GoBackBtn from './GoBackBtn'

const AdSchedule = () => {
    const [startDate , setStartDate] = useState(new Date());
    const [endDate , setEndDate] = useState('');
    const [timeZone , setTimeZone] = useState('');
    const dispatch = useDispatch();

    const submitHandler = e => {
        e.preventDefault();
        dispatch(setNextCompaignTab());
    }

    return (
        <div className='sm:p-8 p-4 '>
            <GoBackBtn />
            <div className='text-primary font-semibold text-lg text-center'>
                Ad Schedule
            </div>
            <form onSubmit={submitHandler}>
                <div className='light-shadow py-6 px-8 rounded-md mt-8'>
                    <h6 className='text-dark font-semibold'>Schedule  (8 days)</h6>
                    <div className='flex items-center gap-4 sm:flex-row flex-col mt-6'>
                        <div className='w-full flex flex-col gap-1'>
                            <label>Start</label>
                            <DatePicker_
                            value={startDate}
                            setValue={setStartDate}
                            />
                        </div>
                        <div className='w-full flex flex-col gap-1'>
                            <label>End</label>
                            <DatePicker_
                            value={endDate}
                            setValue={setEndDate}
                            placeholderText='Select end date'
                            />
                        </div>
                    </div>
                    <div className='w-full flex flex-col gap-1 mt-6'>
                        <label>Time Zone</label>
                        <SelectBox
                        options={[
                            { value : '1' , label : 'Time zone 1'} ,
                            { value : '2' , label : 'Time zone 2'} ,
                            { value : '3' , label : 'Time zone 3'} ,
                            { value : '4' , label : 'Time zone 4'} ,
                        ]}
                        value={timeZone}
                        setValue={setTimeZone}
                        placeholder='Select Time Zone'
                        // required
                        />
                    </div>
                    <div className="mt-12 text-center pb-4">
                        <button className="btn-primary py-1.5 w-[150px]" type='submit'>
                            Next
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}

export default AdSchedule